export default __webpack_public_path__ + "static/media/Icon-Calendar.d904f963.svg";